import { object, string } from 'yup';
import { automationBlockValidation } from 'app/components/management/common/autoamtions/automations-controls-block';
import { TradeType } from 'app/console-api';
import { buildDealValidationSchema } from './trade-type-config';

/**
 * Dynamic validation schema that adapts based on trade type
 * Uses the trade type configuration to determine which fields are required
 */
export const createRequestDealsValidationSchema = (tradeType: TradeType) => {
  const baseSchema = buildDealValidationSchema(tradeType);

  return baseSchema.shape({
    automations: automationBlockValidation
  });
};

/**
 * Legacy schema for backward compatibility
 * @deprecated Use createRequestDealsValidationSchema instead
 */
export const requestDealsValidationSchema = object().shape({
  myApp: object().shape({
    label: string().required('At least one App should be selected'),
    value: string().required('At least one App should be selected'),
    type: string().required('At least one App should be selected')
  }),
  myOffer: object().shape({
    label: string().optional(),
    value: string().optional()
  }).nullable().optional(),
  automations: automationBlockValidation
});

/**
 * Update deal validation schema (used in edit forms)
 * Simpler as deal type cannot be changed after creation
 */
export const createUpdateDealValidationSchema = (tradeType: TradeType) => {
  return buildDealValidationSchema(tradeType, { isUpdate: true });
};

/**
 * Legacy base campaign validation schema
 * @deprecated This is kept for backward compatibility. Use createRequestDealsValidationSchema or createUpdateDealValidationSchema instead.
 */
export const baseCampaignValidationSchema = object().shape({
  title: string()
    .required('Deal title is required')
    .max(100, 'Deal title must be at most 100 characters'),
  customMetadata: string().max(500, 'Metadata must be at most 500 characters')
});
